import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnCheckbox extends ColumnBase {

    private key: string;

    public getContent(row: any): HTMLElement {
        this.key = this.field;
        if (this.field + "_Raw" in row) {
            this.key = this.field + "_Raw";
        }

        if (this.def.visibilityField == 'canBeMandatory') {
            if (this.isCellVisible(row) == false) {
                return <i className="far fa-square mt-checkbox d-none"></i>;
            }
            else {
                if (row[this.key] == 'true' || row[this.key] === true) {
                    return <i className="fas fa-check-square mt-checkbox"></i>;
                }
                else {
                    return <i className="far fa-square mt-checkbox"></i>;
                }
            }
        }
        else {
            if (this.isCellVisible(row)) {
                if (row[this.key] == 'true' || row[this.key] === true) {
                    return <i className="fas fa-check-square mt-checkbox"></i>;
                }
                else {
                    return <i className="far fa-square mt-checkbox"></i>;
                }
            }
        }

    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        if (this.isEditable && this.isCellVisible(rowModel)) {
            cell.classList.add("pointer");
            cell.classList.add("justify-content-center");
            cell.addEventListener("click", () => {
                if (rowModel[this.key] === "true" || rowModel[this.key] === true) {
                    rowModel[this.key] = false;
                    cell.firstElementChild.classList.remove("fa-check-square");
                    cell.firstElementChild.classList.remove("fas");
                    cell.firstElementChild.classList.add("fa-square");
                    cell.firstElementChild.classList.add("far");
                }
                else {
                    rowModel[this.key] = true;
                    cell.firstElementChild.classList.add("fa-check-square");
                    cell.firstElementChild.classList.add("fas");
                    cell.firstElementChild.classList.remove("fa-square");
                    cell.firstElementChild.classList.remove("far");
                }
                if (this.table.props.onModelChanged) {
                    this.table.props.onModelChanged(this.field, rowModel, this.key);
                }
            });
        }
        return cell;
    }
}